<template lang="pug">
  .cost-calculator__table
    .cost-calculator__table-label Доступно
    .cost-calculator__table-input
    .cost-calculator__table-total {{available}} из {{event.amount.total}}

    label.cost-calculator__table-label(for="full-places")
      span.cost-calculator__table-label-title {{priceNormTitle}}
      span.cost-calculator__table-label-price {{priceToString(priceNorm)}}
    .cost-calculator__table-input
      NumberInput(
        id="full-places"
        v-model="full"
        @input="setFullPlaces"
        :min-value="0"
        :max-value="this.event.amount.available"
      )
    .cost-calculator__table-total {{priceToString(userFullPriceSum)}}

    template(v-if="priceDiscount")
      label.cost-calculator__table-label(for="discount-places")
        span.cost-calculator__table-label-title {{priceDiscTitle}}
        span.cost-calculator__table-label-price {{priceToString(priceDiscount)}}
      .cost-calculator__table-input
        NumberInput(
          id="discount-places"
          v-model="discount"
          @input="setDiscountPlaces"
          :min-value="0"
          :max-value="this.event.amount.available"
        )
      .cost-calculator__table-total {{priceToString(userDiscountPriceSum)}}

</template>

<script>
import {mapGetters} from "vuex";
import NumberInput from "@/components/NumberInput";
import priceToString from "@/mixins/price-to-string";

export default {
  name: 'Table',
  mixins: [priceToString],
  components: {NumberInput},
  props: {
    event: {
      type: Object,
    },
    place: {
      type: Object,
    }
  },
  data() {
    return {
      full: 0,
      discount: 0,
    }
  },
  mounted() {
    this.setFullPlaces(1);
  },
  computed: {
    ...mapGetters('config', {
      priceNormTitle: 'getPriceNormTitle',
      priceDiscTitle: 'getPriceDiscTitle'
    }),

    // Общее кол-во мест доступных к выбору
    total() {
      return this.event.amount?.available || 1;
    },
    // Кол-во оставшихся мест для выбора
    available() {
      const available = this.total - this.full - this.discount;
      return available <= 0 ? 0 : available;
    },

    priceNorm() {
      return this.event?.price?.norm ?? 1;
    },
    priceDiscount() {
      return this.event?.price?.disc ?? 0;
    },
    userFullPriceSum() {
      return this.priceNorm * this.full;
    },
    userDiscountPriceSum() {
      return this.priceDiscount * this.discount;
    },
  },
  methods: {
    setFullPlaces(value) {
      this.full = value;
      if (this.available === 0) {
        this.discount = this.total - this.full;
      }
      this.updatePlaces();
    },
    setDiscountPlaces(value) {
      this.discount = value;
      if (this.available === 0) {
        this.full = this.total - this.discount;
      }
      this.updatePlaces();
    },
    updatePlaces() {
      this.$emit('update', {
        eventId: this.event.id,
        full: this.full,
        discount: this.discount,
      })
    }
  }
}

</script>
